import React from "react";
import styled from "styled-components";
import { devReportIgnoreProps } from "./capture";
import { DevReportLauncher } from "./DevReportLauncher";
import { devReportEnvironment } from "./helpers";

const Rail = styled.div`
  position: fixed;
  bottom: ${({ theme }) => theme.space.screen.inset}px;
  left: 50%;
  transform: translateX(-50%);
  z-index: ${({ theme }) => theme.zIndex.topmost};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.sm}px;
`;

/**
 * Holds the QA affordances that sit above every page. Renders nothing at all
 * on builds where none of them are available, so production keeps master's DOM.
 */
export const DevToolsRail = (): JSX.Element | null => {
  if (!devReportEnvironment()) return null;

  return (
    <Rail {...devReportIgnoreProps} data-testid="dev-tools-rail">
      <DevReportLauncher />
    </Rail>
  );
};
